module.exports = __webpack_public_path__ + "static/media/user.6e87b0cd.svg";